import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { CertIcon, CertCourseBoxDesktop } from './style';

const CourseCardCertificateRibbon = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <CertCourseBoxDesktop>
      <Typography
        color={theme.palette.commonText?.primary}
        sx={{ fontSize: { xs: '9px', md: '16px' }, lineHeight: { xs: '9px', md: '18px' }, fontWeight: 700 }}
      >
        {t('home.course_card_certificate')}
      </Typography>
      <CertIcon src="/static/icons/cert-white.svg" alt="cert" />
    </CertCourseBoxDesktop>
  );
};

export default CourseCardCertificateRibbon;
